const TAKEOFF_PALETTE = ['#CC2500','#1e88e5','#43a047','#f4511e','#8e24aa','#00897b','#fb8c00','#3949ab','#d81b60','#546e7a','#000000','#ffffff'];

// Globalūs pagalbiniai — pasiekiami visuose komponentuose
function r2(v) { return Math.round(v * 100) / 100; }

const HEAT_CLASSES = [
  { label: 'A++', wm2: 15 },
  { label: 'A+',  wm2: 20 },
  { label: 'A',   wm2: 25 },
  { label: 'B',   wm2: 35 },
  { label: 'C',   wm2: 50 },
];

export { TAKEOFF_PALETTE, r2, HEAT_CLASSES };
